// @flow
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

import { AUTH0_AUDIENCE, AUTH0_DOMAIN, AUTH0_CLIENT_ID } from '../constants';

type Props = {
  children?: React.Node,
};

const Auth0ProviderWithHistory = (props: Props): React$Element<any> => {
  const audience = AUTH0_AUDIENCE;
  const domain = AUTH0_DOMAIN;
  const clientId = AUTH0_CLIENT_ID;

  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      useRefreshTokens
    >
      {props.children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
